//@flow
import { gql, graphql } from "react-apollo"

const QUERY_KIOSK_OPTIONS = gql`
  query getKioskFormOptions {
    sensors {
      id
      friendlyName
      stationName
    }
  }
`

const withKioskFormOptions = graphql(QUERY_KIOSK_OPTIONS, {
  name: "options"
})

export default withKioskFormOptions



// WEBPACK FOOTER //
// ./src/Kiosks/queries/withKioskFormOptions.js